import { useEffect, useState } from 'react';

import pendingJourneys from './mocks/pendingJourneys.json';
import validatedJourneys from './mocks/journeys.json';
import payment from './mocks/payment.json';
interface Leg {
  timetableId?: string;
  legNumber: number;
  originStationName: string;
  destinationStationName?: string;
  originCode: string;
  destinationCode?: string;
  originId: string;
  originShortName?: string;
  destinationShortName?: string;
  scheduledDepartureDateTime?: string;
  actualDepartureDateTime?: string;
  scheduledArrivalDateTime?: string;
  actualArrivalDateTime?: string;
  callingPoints?: {
    index: number;
    locationCode: string;
    type: string;
  }[];
}
export interface ValidatedJourney {
  id: string;
  customerId: string;
  begin: string;
  end: string;
  orderUri: string;
  requiresProcessing: boolean;
  products: {
    uri?: string;
    fareSearchUrl?: string;
    alternativeIds: string[];
    type: string;
    journeys: any[];
    upgradedAfterCharge: boolean;
  }[];
  determinedJourneys: PaygJourney[];
  profileStatus: string;
  entryPointId: number;
  managedGroupId: number;
  journeysPendingFares: any[];
  rollupPeriodId: string;
}

export interface PaygJourney {
  id?: string;
  legs: Leg[];
  conversationId?: string;
  trackingId: string;
  customerId: string;
  contextUri: string;
  processingStatus?: string;
  journeyDeterminationUri?: string;
  railDay: string;
  journeyStatus: string;
  journeyStatusReason: string;
  trackingStartedDateTime: string;
  trackingStoppedDateTime?: string;
  distanceTravelled?: string;
}

export type CurrencyConversionResponse = {
  value: number;
  currencyCode: string;
};

export enum TransactionStatus {
  SUCCESS = 'Success',
  FAILED = 'Failed',
}
interface transaction {
  date: string;
  amount: CurrencyConversionResponse;
  transactionStatus: string;
  includesPreviousCharges: boolean;
}

export interface Payment {
  total: CurrencyConversionResponse;
  transactionsList: transaction[];
  paymentDetails?: {
    paymentType: string;
    orderId: number;
    paidBy: string;
    card?: {
      type: string;
      tokenisedCardNumber: string;
    };
  };
}

export interface FetchJourneyResponse {
  loading: boolean;
  pendingJourneys: PaygJourney[];
  validatedJourneys: ValidatedJourney[];
  payment: Payment;
}

export const useFetchJourneys = () => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (loading) {
      setTimeout(() => setLoading(false), 800);
    }
  });
  return {
    loading,
    pendingJourneys,
    validatedJourneys,
    payment,
  };
};
